export default __webpack_public_path__ + "static/participation2-7b046ab31605cd45ce02ca834a501641.webp";